/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../app/components/common/checkbox/checkbox.component';
import * as i3 from '@angular/forms';
const styles_CheckboxComponent:any[] = ([] as any[]);
export const RenderType_CheckboxComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CheckboxComponent,data:{}});
export function View_CheckboxComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{model:0}),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),23,'div',[['class','checkbox']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod({'has-error':0,'form-group':1}),(_l()(),i0.ɵted((null as any),
      [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),18,'label',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
      (null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),i0.ɵpod({'disabled':0}),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          5,'input',[['type','checkbox']],[[1,'name',0],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
              'change'],[(null as any),'blur']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.CheckboxComponent = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,10).onChange($event.target.checked)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,10).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.value = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i3.CheckboxControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i3.CheckboxControlValueAccessor]),i0.ɵdid(671744,[[1,4]],0,i3.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {isDisabled:[0,'isDisabled'],model:[1,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i3.NgControl,(null as any),[i3.NgModel]),i0.ɵdid(16384,
          (null as any),0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'span',[['class','checkbox-material']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'span',[['class','check']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),1,'span',[['class','label-text']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['',''])),(_l()(),i0.ɵted((null as any),[' '])),i0.ɵncd((null as any),0),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' ']))],
      (_ck,_v) => {
        var _co:i2.CheckboxComponent = _v.component;
        const currVal_0:any = 'checkbox';
        const currVal_1:any = _ck(_v,3,0,(((_co.form != (null as any)) && (!_co.model.pristine || _co.form.submitted)) && !_co.model.valid),
            (_co.form != (null as any)));
        _ck(_v,2,0,currVal_0,currVal_1);
        const currVal_2:any = _ck(_v,7,0,_co.disabled);
        _ck(_v,6,0,currVal_2);
        const currVal_11:any = _co.disabled;
        const currVal_12:any = _co.value;
        _ck(_v,12,0,currVal_11,currVal_12);
      },(_ck,_v) => {
        var _co:i2.CheckboxComponent = _v.component;
        const currVal_3:any = _co.name;
        const currVal_4:any = i0.ɵnov(_v,14).ngClassUntouched;
        const currVal_5:any = i0.ɵnov(_v,14).ngClassTouched;
        const currVal_6:any = i0.ɵnov(_v,14).ngClassPristine;
        const currVal_7:any = i0.ɵnov(_v,14).ngClassDirty;
        const currVal_8:any = i0.ɵnov(_v,14).ngClassValid;
        const currVal_9:any = i0.ɵnov(_v,14).ngClassInvalid;
        const currVal_10:any = i0.ɵnov(_v,14).ngClassPending;
        _ck(_v,9,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,
            currVal_10);
        const currVal_13:any = (_co.label || '');
        _ck(_v,20,0,currVal_13);
      });
}
export function View_CheckboxComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'checkbox',([] as any[]),
      (null as any),(null as any),(null as any),View_CheckboxComponent_0,RenderType_CheckboxComponent)),
      i0.ɵprd(5120,(null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.CheckboxComponent]),i0.ɵdid(4243456,(null as any),0,i2.CheckboxComponent,
          [[2,i3.NG_VALIDATORS],[2,i3.NG_ASYNC_VALIDATORS]],(null as any),(null as any))],
      (null as any),(null as any));
}
export const CheckboxComponentNgFactory:i0.ComponentFactory<i2.CheckboxComponent> = i0.ɵccf('checkbox',
    i2.CheckboxComponent,View_CheckboxComponent_Host_0,{name:'name',label:'label',
        form:'form',disabled:'disabled'},{},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/common/checkbox/checkbox.component.ngfactory.ts